/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationListRequest {
    getFixupPrototypeFunction() { return AppSecopsApplicationListRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationListRequest>): AppSecopsApplicationListRequest {
        let obj = Object.assign(new AppSecopsApplicationListRequest(), model);
        AppSecopsApplicationListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationListRequest>): AppSecopsApplicationListRequest {
        if (!model) return null;
        return AppSecopsApplicationListRequest.newInstance(<AppSecopsApplicationListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationListRequest) {
        if (!obj) return;

        models.AppSecopsApplicationListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationListRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsApplicationListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AppSecopsApplicationFilterBase.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AppSecopsApplicationSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AppSecopsApplicationSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AppSecopsApplicationFilterBase;

}
